module.exports = __webpack_public_path__ + "68a5aa9d90bb3b3e839f85da688bd552.pdf";